import React from 'react';

import './CancelLink.css';
import { closeModal } from '../../helpers/parent-helper';

interface Props {
  additionalClasses?: string;
}

const CancelLink: React.FC<Props> = props => {
  const { additionalClasses } = props;

  return (
    <div className={`ui-widget-cancel-link ${additionalClasses}`} onClick={closeModal}>
      Select another form of payments
    </div>
  );
};

export default CancelLink;
